import React from 'react';
import {observable, action, computed, makeObservable} from 'mobx';
import {observer} from 'mobx-react';
import s from '../../s';
import * as util from '../../../util';
import {MouldingCustomization} from '../../i';
import {statevent} from '../../api';
import * as emitter from '../../../global/emitter';
import AbTestStore, {ABTestKeys} from '../../../global/store/ab-test.store';
import ModalSimple from '../../../global/modal-simple';
import InfoIcon from '../shared/info-icon';
import {MouldingsList} from './components/mouldings-list';
import {screenResizeStore} from '../../../global/store/screen-resize-store';

declare const bootstrap: any;
declare const window: any;

@observer
export default class Moulding extends React.Component {
    @observable collapsed: boolean = true;
    @observable collapsed_number: number = 6;
    @observable finishes: string[] = [];
    @observable selected_finish: string = '-1';

    constructor(props) {
        super(props);
        this.collapseToggle = this.collapseToggle.bind(this);
        this.save = this.save.bind(this);
        this.changeColor = this.changeColor.bind(this);
        makeObservable(this);
    }

    abForceUpdate = async () => {
        this.forceUpdate();

        if (s.prod.IsCAF) {
            if (AbTestStore.ABIsVariant(ABTestKeys.caf_single, 1)) {
                this.save(141);
            } else if (AbTestStore.ABIsVariant(ABTestKeys.caf_single, 2)) {
                this.save(23376);
            }
        } else if (s.prod.MouldingID && s.prod.MouldingID > 0) {
            this.save(s.prod.MouldingID);
        }
    };

    componentDidMount(): void {
        emitter.eventEmitter.subscribe(emitter.EventType.AB, 'ab', this.abForceUpdate);
        var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
        var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
            bootstrap.Popover.Default.allowList['*'].push('style');
            popoverTriggerEl.addEventListener('click', e => {
                const elements = document.getElementsByClassName('popover bs-popover-auto') as HTMLCollectionOf<HTMLElement>;
                Array.from(elements).forEach(i => (i.style.display = 'none'));
            });
            return new bootstrap.Popover(popoverTriggerEl);
        });

        // console.log(s.prod.mouldings);
        const _all = s.prod.mouldings.filter(x => x.fpc_name && x.fpc_name !== '').map(x => x.fpc_name);
        this.finishes = [...new Set(_all)].sort();
        // console.log(this.finishes);

        if (s.prod.IsCAF) {
            if (AbTestStore.ABIsVariant(ABTestKeys.caf_single, 1)) {
                this.save(141);
            } else if (AbTestStore.ABIsVariant(ABTestKeys.caf_single, 2)) {
                this.save(23376);
            }
        }
    }

    @action
    collapseToggle = async () => {
        this.collapsed = !this.collapsed;
        this.collapsed_number = this.collapsed ? 6 : 1000;
        setTimeout(function () {
            let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
            let popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
                popoverTriggerEl.addEventListener('click', e => {
                    const elements = document.getElementsByClassName('popover bs-popover-auto') as HTMLCollectionOf<HTMLElement>;
                    Array.from(elements).forEach(i => (i.style.display = 'none'));
                });
                return new bootstrap.Popover(popoverTriggerEl);
            });
        });
    };

    @action
    save = async (id: number) => {
        util.prod_entity_zoom_destroy();
        s.ui.update_pricing = true;
        s.pcs.moulding_id = id;
        const x = s.prod.mouldings.filter(xx => xx.id === id)[0];
        if (x) {
            s.pcs.moulding_extWidth = x.extWidth;
            s.ui.moulding_th5 = x.th5 ? true : false;
            s.ui.moulding_th6 = x.th6 ? true : false;
        }

        s.pulse();

        if (window.innerWidth < 1200) {
            const d = document.getElementById('prod-header') as HTMLDivElement;
            d.scrollIntoView();
        }

        if (!s.prod.IsCAF && s.isRetail && id !== s.prod.MouldingID) {
            statevent({
                d1: 'cust_moulding',
                d2: s.prod.MouldingID.toString(),
                d3: id.toString(),
            });
        }
    };

    @action
    changeColor = async e => {
        this.selected_finish = e.target.value as string;
        if (this.selected_finish === '-1') {
            this.collapsed_number = this.collapsed ? 6 : 1000;
        } else {
            this.collapsed_number = 1000;
            if (this.collapsed) {
                this.collapseToggle();
            }
        }
    };
    @computed get canCollapse(): boolean {
        return s.pcs.is_caf || this.isMobile;
    }

    @computed get isMobile(): boolean {
        return screenResizeStore.width < 960;
    }

    render() {
        if (!s.ready || !s.ui.show_cust || !s.prod.mouldings) {
            return;
        }

        return (
            <div
                className="gray-box"
                style={{position: 'relative', padding: 0}}
            >
                <div>
                    <div>
                        <div
                            style={{
                                padding: '0 12px',
                                position: 'relative',
                            }}
                        >
                            <div
                                role={this.canCollapse ? 'button' : undefined}
                                tabIndex={this.canCollapse ? 0 : undefined}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        e.currentTarget.click();
                                    }
                                }}
                                className="d-none d-xl-block toggle-bs"
                                data-bs-toggle={this.canCollapse ? 'collapse' : ''}
                                data-bs-target="#moulding-inner"
                                aria-expanded={this.canCollapse ? false : undefined}
                                aria-controls={this.canCollapse ? 'moulding-inner' : undefined}
                            >
                                <div
                                    className="cust-desktop-head"
                                    style={{paddingBottom: s.prod.IsCAF ? 8 : 0}}
                                >
                                    <span>Frame Moulding: </span>
                                    <span>{s.ui.title_moulding}</span>
                                </div>
                            </div>

                            <div
                                role={this.canCollapse ? 'button' : undefined}
                                tabIndex={this.canCollapse ? 0 : undefined}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        e.currentTarget.click();
                                    }
                                }}
                                className="d-block d-xl-none toggle-bs"
                                data-bs-toggle={this.canCollapse ? 'collapse' : ''}
                                data-bs-target="#moulding-inner"
                                aria-expanded={this.canCollapse ? false : undefined}
                                aria-controls={this.canCollapse ? 'moulding-inner' : undefined}
                            >
                                <div className="cust-flex-head">
                                    <div>
                                        <div
                                            className="header-std flexer cust-flex2"
                                            style={{paddingRight: '0.25rem'}}
                                        >
                                            Frame Moulding
                                        </div>
                                        <div className="cust-flex2">{s.ui.title_moulding}</div>
                                    </div>
                                    <div>
                                        {this.canCollapse &&
                                            this.collapsed &&
                                            s.prod.mouldings
                                                .filter(m => m.id === s.pcs.moulding_id)
                                                .map((m: MouldingCustomization, i: number) => (
                                                    <img
                                                        key={i}
                                                        src={`https://${s.Portal.CDNDomain}/images/entities/moulding/${m.name.toLowerCase()}_thumb_90.png`}
                                                        alt={m.title}
                                                    />
                                                ))}
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: this.isMobile ? 6 : s.pcs.is_caf ? 10 : 5,
                                    left: this.isMobile ? 140 : 'auto',
                                    right: s.pcs.is_caf ? 40 : !this.isMobile ? 8 : 'auto',
                                }}
                            >
                                <InfoIcon
                                    id="modal-moulding"
                                    ariaLabel="Open dialog with moulding information for this product"
                                    useMargin={true}
                                    styleBlack={true}
                                />
                            </div>
                        </div>

                        <div
                            id="moulding-inner"
                            className={this.canCollapse ? 'collapse' : ''}
                            style={{padding: '0 12px'}}
                        >
                            {s.prod && s.prod.IsCAF && (
                                <div>
                                    <div
                                        className="cust-lino-select"
                                        style={{width: '100%'}}
                                    >
                                        <label htmlFor="moulding-finish">Finish Color:</label>
                                        <select
                                            id="moulding-finish"
                                            className="form-select"
                                            aria-label="Select finish color"
                                            onChange={this.changeColor}
                                            style={{width: 160, marginLeft: 8}}
                                        >
                                            <option value="-1">View All</option>
                                            {this.finishes.map(x => (
                                                <option value={x}>{x}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <hr style={{margin: '0.5rem 0'}} />
                                </div>
                            )}

                            <MouldingsList
                                collapsed={this.collapsed}
                                collapsedNumber={this.collapsed_number}
                                selectedFinish={this.selected_finish}
                                save={this.save}
                                showNames={false}
                            />

                            {s.prod.mouldings.length >= 6 && (
                                <button
                                    className="btn btn-outline-secondary btn-sm btn-toggle"
                                    onClick={this.collapseToggle}
                                    style={{margin: '4px 0 2px 0', color: '#000000', display: 'flex', justifySelf: 'center'}}
                                    aria-label={this.collapsed ? `+ View all ${s.prod.mouldings.length} mouldings` : '- View less mouldings'}
                                >
                                    {this.collapsed ? `+ View all ${s.prod.mouldings.length} mouldings` : '- View less mouldings'}
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                <ModalSimple
                    id="modal-moulding"
                    title="Moulding Information"
                >
                    <p>
                        A wood frame is a handcrafted border made from high-quality wood mouldings,designed to beautifully protect and showcase your diploma, certificate, or special keepsake. Our frames come in a variety of classic and modern styles, with options ranging from sleek, minimal profiles
                        to elegant, deep shadowbox designs. Each frame is available in different finishes and colors, ensuring a perfect match for your decor or personal taste. Whether you choose a timeless traditional look or a contemporary design, our wood frames offer durability, sophistication,
                        and exceptional value, all tailored to highlight your achievement.
                    </p>
                </ModalSimple>
            </div>
        );
    }
}
